import { createSlice } from "@reduxjs/toolkit";
import isEqual from 'lodash/isEqual';
const initialState = {
	data: null,
	loading: false,
	error: null,
};

const workflowListSlice = createSlice({
	name: "workflowList",
	initialState,
	reducers: {
		fetchworkflowListRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchworkflowListSuccess: (state, action) => {

			state.loading = false;
			// Only update if data actually changed
			if (!state.data?.workflowsResponseList ||
				!isEqual(state.data.workflowsResponseList, action.payload?.data?.workflowsResponseList)) {
				state.data = action.payload;
			}
		},
		fetchworkflowListFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

export const { fetchworkflowListRequest, fetchworkflowListSuccess, fetchworkflowListFailure } = workflowListSlice.actions;

export default workflowListSlice.reducer;
